import {
    PROJECTSVIEW_UPDATE_PRODUCT,
    PROJECTSVIEW_UPDATE_PARENT_PROJECT,
    PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT,
    PROJECTSVIEW_CLEAN
} from 'reducers/constants';

export const updateProduct = (product) => dispatch => {
    dispatch(
        {
            type: PROJECTSVIEW_UPDATE_PRODUCT,
            payload: product
        }
    )
}

export const updateParentProject = (project) => dispatch => {
    dispatch(
        {
            type: PROJECTSVIEW_UPDATE_PARENT_PROJECT,
            payload: project
        }
    )
}

export const updateCommercialProject = (project) => dispatch => {
    dispatch(
        {
            type: PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT,
            payload: project
        }
    )
}

export const cleanState = () => dispatch => {
    dispatch(
        {
            type: PROJECTSVIEW_CLEAN,
            payload: ""
        }
    )
}


// WEBPACK FOOTER //
// ./src/reducers/projectsview/projectsviewActions.js